import React from "react";
import "./QuoteContainer.css";

function QuoteComponent() {
  const openInstagram = () => {
    window.open("https://www.instagram.com/elaichi_love", "_blank");
  };

  return (
    <div className="quote-section">
      <div className="quote-section-inner">
        <div className="reel-left-col">
          <span className="reel-case-stat">Join the movement</span>
          <h1 className="bakery-heading">
            Viral Karak Chai. <br />Wellness that connects.
          </h1>
          <p className="info-text" style={{ marginTop: "1.2rem" }}>
            Explore our Soul Collection - brewed chai, Sticky Soul concentrate balls, and the Chai Pe Charcha monthly box. Add snacks from the Crunch Collection, Berry Banger wellness shots, and ritual subscription boxes. Simple, soulful, delivered.
          </p>
          <p className="info-text">
            Glasgow & UK delivery. Events, pop-ups, and our future café. Join our WhatsApp Community for the latest drops and community Iftars, festivals, and wellness workshops.
          </p>
          <div className="insta-profile-card">
            <img src="/instaprofile.jpeg" alt="Elaichi & Love" />
            <div className="insta-profile-details">
              <button
                className="insta-profile-name"
                onClick={openInstagram}
                style={{
                  background: "none",
                  border: "none",
                  color: "inherit",
                  cursor: "pointer",
                  padding: 0,
                  font: "inherit",
                }}
                aria-label="Open Elaichi & Love Instagram"
              >
                @elaichi_love
              </button>
              <button
                className="insta-profile-followers"
                onClick={openInstagram}
                style={{
                  background: "none",
                  border: "none",
                  color: "inherit",
                  cursor: "pointer",
                  padding: 0,
                  font: "inherit",
                }}
                aria-label="Open Elaichi & Love Instagram"
              >
                Let&apos;s connect
              </button>
            </div>
          </div>
        </div>
        <div className="reel-right-col">
          <div className="reel-video-card">
            <video
              className="cake-video"
              src="./Video-801.mp4"
              autoPlay
              muted
              loop
            />
            <button
              className="video-credit"
              onClick={openInstagram}
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
              }}
              aria-label="Open Elaichi & Love Instagram"
            >
              @elaichi_love
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuoteComponent;
